// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"Fna-z","beautyGrouping":"Gna-z","beautySwatches":"Hna-z","swatches":"Ina-z"};